import type { ContentHref } from '@generalTypes/apiTypes';
import { selectBaselineRelationsToAndFromMap } from '@newStore/documentApi/documentApiSelectors';
import { selectAppliedDocumentRootConfig } from '@newStore/documentUI/nodeTypeConfigSelectors';
import {
  getReferenceNodes,
  selectReferenceNodes,
} from '@newStore/documentUI/transformContent/referenceGroupSelectors';
import { getDiffForArraysOfStrings } from '@newStore/documentUI/transformProposal/asideDiffText';
import { selectProposedContentHrefsToDelete } from '@newStore/documentUI/transformProposal/proposalSelectors';
import {
  selectAllExternalData,
  selectExternalContent,
  selectExternalContentRelationsMap,
} from '@newStore/externalData/externalDataSelectors';
import { createTypedSelector } from '@newStore/genericHelpers';
import constants from '@store/constants/constants';

const defaultReferenceGroupTypes = [
  constants.referenceGroupTypes.WEBPAGE2,
  constants.referenceGroupTypes.VISION_TEXT,
  constants.referenceGroupTypes.CURRICULUM_ZILL,
  constants.referenceGroupTypes.ZILL_ILLUSTRATION,
];

export const selectReferenceGroupTypes = createTypedSelector(
  [(state) => selectAppliedDocumentRootConfig(state)],
  (appliedDocumentRootConfig) =>
    appliedDocumentRootConfig?.referenceGroupTypes || defaultReferenceGroupTypes,
);

const selectRawReferenceNodes = createTypedSelector(
  [
    (state) => selectBaselineRelationsToAndFromMap(state),
    (state, href: ContentHref) => href,
    (state) => selectAllExternalData(state),
    (state) => selectExternalContentRelationsMap(state),
    (state) => selectExternalContent(state),
    (state) => selectProposedContentHrefsToDelete(state),
  ],
  getReferenceNodes,
);

export const selectChangeMessageForReferenceGroup = createTypedSelector(
  [
    (state, href: ContentHref) => selectReferenceNodes(state, href),
    (state, href: ContentHref) => selectRawReferenceNodes(state, href),
  ],
  (referenceNodes, rawReferenceNodes) => {
    const diffRelations = getDiffForArraysOfStrings(
      rawReferenceNodes.map((r) => r.title),
      referenceNodes.map((r) => r.title),
    );
    return diffRelations || null;
  },
);
